import classNames from 'classnames';

import { AD_BLOCKER_HINT } from '@helpers/adBlocker';

import Styles from './AdBlockerHint.module.scss';

// Shared inline hint shown when a request looks blocked by an ad-blocker. Pair with
// `isAdBlockerError` and mount it conditionally, e.g. `{isBlocked && <AdBlockerHint />}`.
const AdBlockerHint = ({ message = AD_BLOCKER_HINT, className }) => (
  <div className={classNames(Styles.hint, className)}>{message}</div>
);

export default AdBlockerHint;
